module.exports = __webpack_public_path__ + "documentacao.jpeg?6ef4b7e085ae717d45b204fc0ebf0b35";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documentacao.jpeg
// module id = 733
// module chunks = 0